import { render, staticRenderFns } from "./InventoryInputs.vue?vue&type=template&id=ea13c3b4&"
import script from "./InventoryInputs.vue?vue&type=script&lang=ts&"
export * from "./InventoryInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports